export enum Mode {
  Preclaim = "Preclaim",
  Mint = "Mint",
  Story = "Story",
  Box = "Box",
}
